import React, {Component} from 'react';
import {Button} from 'antd';
import StationModalForm from './StationModalForm';

class StationButtonUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {station, onUpdate} = this.props
      const updateStation = {
        ...station
      }
      const {Name, UserName, Password, MoreInfo} = values
      const addr = MoreInfo.addr
        ? MoreInfo.addr
        : ""
      const desc = MoreInfo.desc
        ? MoreInfo.desc
        : ""
      const lat = MoreInfo.lat
        ? MoreInfo.lat
        : 0
      const lng = MoreInfo.lng
        ? MoreInfo.lng
        : 0
      updateStation.Name = Name
      updateStation.UserName = UserName
      updateStation.Password = Password
      const jsonString = JSON.stringify({addr: addr, desc: desc, lat: lat, lng: lng, UserName: UserName, Password: Password})
      const info = btoa(unescape(encodeURIComponent(jsonString)))
      updateStation.MoreInfo = info
      onUpdate(updateStation)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {station, stations} = this.props
    return (<span>
      <Button onClick={this.showModal} type="primary" ghost="ghost" size="small">
        Edit
      </Button>
      <StationModalForm ref={this.saveFormRef} title="Cập nhật thông tin trạm" station={station} stations={stations} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default StationButtonUpdate;



// WEBPACK FOOTER //
// ./src/components/StationButtonUpdate.js